import React, { useMemo } from 'react';
import NodeListMenu from '../NodeListMenu/NodeListMenu';
import { Pack } from '../reducer/packVertices';
import { GraphData, GraphVertex } from '../types';

interface Props {
  open: boolean;
  graphData: GraphData;
  inspectedNodeId: string | null;
  pack?: Pack;
  onSelectNode: (id: string) => void;
}

const PackContextMenu = ({
  graphData,
  pack,
  open,
  inspectedNodeId,
  onSelectNode,
}: Props) => {
  const vertices: GraphVertex[] = useMemo(() => {
    if (!pack) {
      return [];
    }
    return graphData.vertices.filter(
      (v) => pack.packedVerticesIds.indexOf(v.id) >= 0
    );
  }, [graphData, pack]);

  if (!pack) {
    return null;
  }

  return (
    <NodeListMenu
      open={open}
      selectedNodeId={inspectedNodeId}
      onSelectNode={onSelectNode}
      vertices={vertices}
    />
  );
};

export default PackContextMenu;
